import _implicitStylesheets from "./listingDetail.css";
import _implicitScopedStylesheets from "./listingDetail.scoped.css?scoped=true";
import _axAlert from "ax/alert";
import _listingPrivacyBanner from "listing/privacyBanner";
import _adsImage from "ads/image";
import _wdsContentText from "wds/contentText";
import _wdsStarRatings from "wds/starRatings";
import _axBar from "ax/bar";
import _wdsLink from "wds/link";
import _wdsRatingSummary from "wds/ratingSummary";
import _wdsButton from "wds/button";
import _wdsIconInteractive from "wds/iconInteractive";
import _listingPricingSummary from "listing/pricingSummary";
import _wdsTitledGroup from "wds/titledGroup";
import _aceQualifiedChat from "ace/qualifiedChat";
import _listingCarousel from "listing/carousel";
import _wdsTabGroup from "wds/tabGroup";
import _listingOverview from "listing/overview";
import _listingReviews from "listing/reviews";
import _listingMoreDetails from "listing/moreDetails";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="listing-title${0}"${2}><h1 type-style="display-6" tabindex="0"${3}>${"t2"}</h1><p type-style="body-3"${3}>${"t4"}</p></div>`;
const $fragment2 = parseFragment`<p class="summary-description${0}" type-style="body-2"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<hr${3}>`;
const $fragment4 = parseFragment`<div class="listing-description-wrapper${0}"${2}><p type-style="body-2" class="listing-description${0}"${2}>${"t2"}</p></div>`;
const $fragment5 = parseFragment`<p type-style="body-2" class="listing-description${0}"${2}>${"t1"}</p>`;
const stc0 = {
  "listing-detail-wrapper": true
};
const stc1 = {
  key: 2
};
const stc2 = {
  classMap: {
    "summary": true
  },
  attrs: {
    "grid": "",
    "axis": "row"
  },
  key: 3
};
const stc3 = {
  classMap: {
    "listing-logo": true
  },
  key: 4
};
const stc4 = {
  "lwc-cmp": true,
  "image": true
};
const stc5 = {
  classMap: {
    "summary-details": true
  },
  key: 8
};
const stc6 = {
  classMap: {
    "rating-loading": true
  },
  key: 11
};
const stc7 = {
  "lwc-cmp": true,
  "stars": true
};
const stc8 = {
  slotAssignment: "label",
  classMap: {
    "rating-loading-text": true
  },
  key: 13
};
const stc9 = {
  props: {
    "isLoading": "true"
  },
  key: 14
};
const stc10 = {
  classMap: {
    "solution-type-and-rating-wrapper": true
  },
  key: 15
};
const stc11 = {
  "non-clickable-bar": true
};
const stc12 = {
  slotAssignment: "label",
  classMap: {
    "reviews-count-label": true
  },
  attrs: {
    "aria-hidden": "true"
  },
  key: 18
};
const stc13 = {
  slotAssignment: "label",
  attrs: {
    "type-style": "body-3",
    "data-testid": "no-reviews-label"
  },
  key: 20
};
const stc14 = {
  classMap: {
    "listing-content": true
  },
  attrs: {
    "grid": "",
    "axis": "row"
  },
  key: 23
};
const stc15 = {
  classMap: {
    "info-wrapper": true
  },
  key: 24
};
const stc16 = {
  classMap: {
    "actions-and-price-wrapper": true
  },
  key: 25
};
const stc17 = {
  "listing-actions": true
};
const stc18 = {
  "data-testid": "get-it-now-btn"
};
const stc19 = {
  "trial-button": true
};
const stc20 = {
  "data-testid": "add-favorites-btn"
};
const stc21 = {
  classMap: {
    "listing-price": true
  },
  key: 30
};
const stc22 = {
  classMap: {
    "titled-groups-container": true
  },
  key: 34
};
const stc23 = {
  classMap: {
    "titled-groups-wrapper": true
  },
  key: 35
};
const stc24 = {
  "titled-group-wrapper": true
};
const stc25 = {
  "data-testid": "require-products-div"
};
const stc26 = {
  "data-testid": "recommended-products-div"
};
const stc27 = {
  attrs: {
    "type-style": "body-3"
  },
  key: 40
};
const stc28 = {
  "partner-chat-btn": true
};
const stc29 = {
  classMap: {
    "partner-chat-btn": true
  },
  props: {
    "width": "fill",
    "variant": "secondary",
    "name": "chat with provider",
    "label": "Loading...",
    "size": "xsmall"
  },
  key: 45
};
const stc30 = {
  classMap: {
    "carousel-wrapper": true
  },
  key: 46
};
const stc31 = {
  "carousel": true
};
const stc32 = {
  "data-id": "tab-group"
};
const stc33 = {
  "data-testid": "overview-panel"
};
const stc34 = {
  "data-testid": "reviews-panel"
};
const stc35 = {
  "data-testid": "moreDetails-panel"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, t: api_text, ncls: api_normalize_class_name, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12} = $ctx;
  return [$cmp.isSupportedListing ? api_element("div", {
    classMap: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [$cmp.showTrialInformationAlert ? api_custom_element("ax-alert", _axAlert, {
    props: {
      "alertMessage": $cmp.trialInformationAlertProps.message,
      "alertActionMessage": $cmp.trialInformationAlertProps.actionMessage,
      "alertAction": $cmp.trialInformationAlertProps.action,
      "variant": "info"
    },
    key: 1,
    on: {
      "close": _m1 || ($ctx._m1 = api_bind($cmp.closeTrialInformationAlert))
    }
  }) : null, $cmp.isPrivateListing ? api_custom_element("listing-privacy-banner", _listingPrivacyBanner, stc1) : null, api_element("div", stc2, [api_element("div", stc3, [api_custom_element("ads-image", _adsImage, {
    classMap: stc4,
    props: {
      "src": $cmp.logo,
      "width": "60px",
      "height": "60px",
      "isLoading": $cmp.isListingLoading,
      "alt": $cmp.logoAlt,
      "fallback": "circle",
      "variant": "basic",
      "loadingBorder": "false"
    },
    key: 5
  })]), api_static_fragment($fragment1, 7, [api_static_part(2, null, api_dynamic_text($cmp.listing.name)), api_static_part(4, null, api_dynamic_text($cmp.publisherByLine))]), api_element("div", stc5, [api_static_fragment($fragment2, 10, [api_static_part(1, null, api_dynamic_text($cmp.searchBlurb))]), $cmp.isListingLoading ? api_element("div", stc6, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
    classMap: stc7,
    props: {
      "size": "medium",
      "spaceBetween": "xsmall",
      "readOnly": true,
      "labelPosition": $cmp.ratingSummaryLabelPosition
    },
    key: 12
  }, [api_element("div", stc8, [api_custom_element("wds-content-text", _wdsContentText, stc9)])])]) : null, !$cmp.isListingLoading ? api_element("div", stc10, [$cmp.isSupportedTechnologyType ? api_custom_element("ax-bar", _axBar, {
    classMap: stc11,
    props: {
      "text": $cmp.solutionType,
      "iconSetType": "product",
      "icon": $cmp.iconTechnologySymbol,
      "variant": "primary",
      "size": "small"
    },
    key: 16
  }) : null, $cmp.listing ? $cmp.listing.reviewsSummary ? api_custom_element("wds-rating-summary", _wdsRatingSummary, {
    props: {
      "averageRating": $cmp.averageRating,
      "reviewsCount": $cmp.reviewCount,
      "labelPosition": $cmp.ratingSummaryLabelPosition
    },
    key: 17
  }, [api_element("span", stc12, [api_text(api_dynamic_text($cmp.averageRatingLabel) + "  ("), api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "reviews",
      "i18nMessage": $cmp.reviewsCountLabel
    },
    key: 19,
    on: {
      "scrolltoreview": _m2 || ($ctx._m2 = api_bind($cmp.navigateReviewsURL))
    }
  }), api_text(")")])]) : null : null, $cmp.listing ? !$cmp.listing.reviewsSummary ? api_element("span", stc13, [api_text(api_dynamic_text($cmp.i18n.listingDetails.reviews.noReviews))]) : null : null]) : null])]), $cmp.isMobilePhone ? api_static_fragment($fragment3, 22) : null, api_element("div", stc14, [api_element("div", stc15, [api_element("div", stc16, [api_element("div", {
    classMap: stc17,
    key: 26,
    on: {
      "analytics": _m3 || ($ctx._m3 = api_bind($cmp.handleActionsAnalytics))
    }
  }, [api_custom_element("wds-button", _wdsButton, {
    attrs: stc18,
    props: {
      "label": $cmp.i18n.listingDetails.getItNowButtons.getItNow,
      "variant": "primary",
      "name": "get it now"
    },
    key: 27,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.handleGetItNowCTA))
    }
  }), $cmp.hasTrialOptions ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc19,
    props: {
      "href": $cmp.tryButtonHref,
      "label": $cmp.i18n.listingDetails.getItNowButtons.tryForFree,
      "variant": "secondary",
      "name": "try it free"
    },
    key: 28
  }) : null, api_custom_element("wds-icon-interactive", _wdsIconInteractive, {
    className: api_normalize_class_name($cmp.favoriteButtonClassName),
    attrs: stc20,
    props: {
      "icon": $cmp.favoriteButtonIcon,
      "iconDescription": $cmp.favoriteButtonIconDescription,
      "name": "add to favorites",
      "theme": "red",
      "size": "large"
    },
    key: 29,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleFavoriteListings))
    }
  })]), api_element("div", stc21, [api_custom_element("listing-pricing-summary", _listingPricingSummary, {
    props: {
      "pricing": $cmp.pricingPlan
    },
    key: 31,
    on: {
      "linkclick": _m6 || ($ctx._m6 = api_bind($cmp.handlePricingSummaryLinkClick))
    }
  })])]), $cmp.isMobilePhone ? api_static_fragment($fragment4, 33, [api_static_part(2, null, api_dynamic_text($cmp.formattedDescription))]) : null, api_element("div", stc22, [api_element("div", stc23, [$cmp.industryBadges.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc24,
    props: {
      "title": $cmp.i18n.listingDetails.industriesGroup,
      "badges": $cmp.industryBadges
    },
    key: 36
  }) : null, $cmp.categoryBadges.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc24,
    props: {
      "title": $cmp.i18n.listingDetails.categoriesGroup,
      "badges": $cmp.categoryBadges
    },
    key: 37
  }) : null, $cmp.requiresProducts.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc24,
    attrs: stc25,
    props: {
      "title": $cmp.i18n.compatibility.requiredProductsGroup,
      "badges": $cmp.requiresProducts
    },
    key: 38
  }) : null, $cmp.compatibilityWith.length ? api_custom_element("wds-titled-group", _wdsTitledGroup, {
    classMap: stc24,
    attrs: stc26,
    props: {
      "title": $cmp.i18n.compatibility.compatibleWith,
      "badges": $cmp.compatibilityWith
    },
    key: 39
  }) : null]), api_element("div", stc27, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "more details",
      "i18nMessage": $cmp.moreDetailsLink
    },
    key: 41,
    on: {
      "scrolltomoredetail": _m7 || ($ctx._m7 = api_bind($cmp.navigateMoreDetailsURL))
    }
  })]), $cmp.disableAutoLoadQualifiedChat ? $cmp.displayChat ? api_custom_element("ace-qualified-chat", _aceQualifiedChat, {
    props: {
      "chattoken": $cmp.chatToken,
      "usertoken": $cmp.userToken,
      "showchatpanel": $cmp.showQualifiedChatPanel
    },
    key: 42,
    on: {
      "hidechat": _m8 || ($ctx._m8 = api_bind($cmp.handleHideQualifiedChat)),
      "chatloaded": _m9 || ($ctx._m9 = api_bind($cmp.handleQualifiedChatLoaded))
    }
  }) : null : null, !$cmp.disableAutoLoadQualifiedChat ? $cmp.displayChat ? api_custom_element("ace-qualified-chat", _aceQualifiedChat, {
    props: {
      "chattoken": $cmp.chatToken,
      "usertoken": $cmp.userToken
    },
    key: 43
  }) : null : null]), $cmp.showQualifiedChatButton ? !$cmp.isQualifiedChatLoading ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc28,
    props: {
      "width": "fill",
      "variant": "secondary",
      "icon": "chat",
      "name": "chat with provider",
      "label": $cmp.i18n.listingDetails.getItNowButtons.chatWithProvider,
      "size": "xsmall"
    },
    key: 44,
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.handleOpenChat))
    }
  }) : null : null, $cmp.showQualifiedChatButton ? $cmp.isQualifiedChatLoading ? api_custom_element("wds-button", _wdsButton, stc29) : null : null]), api_element("div", stc30, [!$cmp.isMobilePhone ? api_static_fragment($fragment5, 48, [api_static_part(1, null, api_dynamic_text($cmp.formattedDescription))]) : null, api_custom_element("listing-carousel", _listingCarousel, {
    classMap: stc31,
    props: {
      "mediaItems": $cmp.carouselItems,
      "providerLogo": $cmp.logo,
      "isMobile": $cmp.isMobilePhone,
      "hasDemoLeadsEnabled": $cmp.hasDemoLeadsEnabled
    },
    key: 49
  })])]), api_custom_element("wds-tab-group", _wdsTabGroup, {
    attrs: stc32,
    props: {
      "tabs": $cmp.tabs,
      "mobile": $cmp.isMobilePhone
    },
    key: 50,
    on: {
      "tabregister": _m11 || ($ctx._m11 = api_bind($cmp.handleTabRegister)),
      "keydown": _m12 || ($ctx._m12 = api_bind($cmp.handleTabGroupKeyDown))
    }
  }), $cmp.showOverview ? api_custom_element("listing-overview", _listingOverview, {
    attrs: stc33,
    props: {
      "id": api_scoped_id("overview-panel"),
      "role": "tabpanel",
      "listing": $cmp.listing
    },
    key: 51
  }) : null, $cmp.showReviews ? api_custom_element("listing-reviews", _listingReviews, {
    attrs: stc34,
    props: {
      "id": api_scoped_id("reviews-panel"),
      "role": "tabpanel",
      "reviewSummary": $cmp.reviewSummary
    },
    key: 52
  }) : null, $cmp.showMoreDetails ? api_custom_element("listing-more-details", _listingMoreDetails, {
    attrs: stc35,
    props: {
      "id": api_scoped_id("moreDetails-panel"),
      "listing": $cmp.listing,
      "role": "tabpanel"
    },
    key: 53
  }) : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-775j35eqo0h";
tmpl.legacyStylesheetToken = "undefined-_listingDetail";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
